exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Badge-36a7121c{color:white;display:inline-block;padding:2px 8px;margin:-2px 0;border-radius:3px}.default-c1988b94{background:#999}\n", ""]);

// Exports
exports.locals = {
	"Badge": "Badge-36a7121c",
	"default": "default-c1988b94"
};